export default function CheckIcon() {
  return (
    <svg
      version="1.1"
      width="20"
      height="20"
      x="0"
      y="0"
      viewBox="0 0 24 24"
    >
      <g>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M20.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L10 15.586l9.293-9.293a1 1 0 0 1 1.414 0z"
          clipRule="evenodd"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}
